import React from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import { CmsViewDevicesListDatatable } from "@/helpers/cmsViewDevicesListDatatable";

function ViewDevicesModal({ open, viewType, onClose, templateId }) {
  const { t } = useTranslation();

  return (
    <Modal
      title={
        viewType === "installNum"
          ? t({ defaultMessage: "已安装设备数量" })
          : t({ defaultMessage: "待安装设备数量" })
      }
      width={800}
      open={open}
      showConfirm={false}
      onClose={onClose}
    >
      <CmsViewDevicesListDatatable
        templateId={templateId}
        viewType={viewType}
      />
    </Modal>
  );
}

export default ViewDevicesModal;
